import { Home, History, Upload, Settings } from 'lucide-react';
import { useLocation, useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';

const navItems = [
  { path: '/', icon: Home, label: 'Home' },
  { path: '/history', icon: History, label: 'History' },
  { path: '/export', icon: Upload, label: 'Export' },
  { path: '/settings', icon: Settings, label: 'Settings' },
];

export const Navigation = () => {
  const location = useLocation();
  const navigate = useNavigate();
  
  // Hide navigation on certain screens
  const hiddenPaths = ['/onboarding', '/passcode', '/daily-log', '/help'];
  if (hiddenPaths.some(path => location.pathname.startsWith(path))) {
    return null;
  }

  return (
    <nav 
      className="fixed bottom-0 left-0 right-0 z-50 backdrop-blur-xl bg-theme-light border-t border-theme-secondary"
      data-testid="bottom-navigation"
    >
      <div className="max-w-md mx-auto">
        {/* Navigation Tabs */}
        <div className="flex items-center justify-around py-2 px-4">
          {navItems.map(({ path, icon: Icon, label }) => {
            const isActive = location.pathname === path;
            
            return (
              <button
                key={path}
                onClick={() => navigate(path)}
                className="relative flex flex-col items-center gap-1 p-1.5 transition-colors"
                data-testid={`nav-${label.toLowerCase()}`}
                aria-label={label}
              >
                <div className="relative">
                  <Icon 
                    size={24} 
                    strokeWidth={1.5}
                    className={`transition-colors ${
                      isActive ? 'text-theme-accent' : 'text-secondary'
                    }`}
                  />
                  {isActive && (
                    <motion.div
                      layoutId="nav-indicator"
                      className="absolute -bottom-1 left-1/2 -translate-x-1/2 w-1 h-1 bg-theme-accent rounded-full"
                      transition={{ type: 'spring', stiffness: 400, damping: 30 }}
                    />
                  )}
                </div>
                <span
                  className={`text-xs transition-colors ${
                    isActive ? 'text-theme-accent font-medium' : 'text-secondary'
                  }`}
                >
                  {label}
                </span>
              </button>
            );
          })}
        </div>
      </div>
    </nav>
  );
};

export default Navigation;
